import type * as React from "react";
import { cn } from "../lib/cn";

/** Breadcrumb: links separated by "/", the last item is the current page. */
export function Breadcrumb({
  items,
  className,
}: {
  items: { label: string; href?: string; render?: (label: string) => React.ReactNode }[];
  className?: string;
}) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn("flex min-w-0 items-center gap-2 text-[13px] text-muted-foreground", className)}
    >
      {items.map((item, index) => {
        const last = index === items.length - 1;
        return (
          <span
            key={`${item.label}:${item.href ?? ""}`}
            // On a phone only the current page fits; the trail returns from sm up.
            className={cn("min-w-0 items-center gap-2", last ? "flex" : "hidden sm:flex")}
          >
            {last ? (
              <span aria-current="page" className="truncate font-medium text-foreground">
                {item.label}
              </span>
            ) : (
              (item.render?.(item.label) ?? <span className="truncate">{item.label}</span>)
            )}
            {last ? null : <span aria-hidden>/</span>}
          </span>
        );
      })}
    </nav>
  );
}
